import { X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const WHATSAPP_NUMBER = "250788570601";

export default function WhatsAppChatWidget() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const boxRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const openWhatsApp = () => {
    const text = encodeURIComponent(message || "Hello 👋");
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
    window.open(url, "_blank");
    setMessage("");
    setOpen(false);
  };

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-5 right-5 z-[9999]
          w-14 h-14 rounded-full bg-[#25D366]
          flex items-center justify-center shadow-xl
          hover:scale-105 transition-transform"
      >
        <FaWhatsapp className="w-7 h-7 text-white" />
      </button>

      {/* Popup */}
      {open && (
        <div
          ref={boxRef}
          className="fixed bottom-24 right-5 z-[9999]
            w-80 rounded-2xl shadow-2xl
            bg-white overflow-hidden
            animate-[fadeInUp_0.25s_ease-out]"
        >
          {/* Header */}
          <div className="bg-[#075E54] text-white px-4 py-3 flex justify-between items-center">
            <span className="font-semibold">WhatsApp Chat</span>
            <button onClick={() => setOpen(false)}>
              <X className="w-4 h-4" />
            </button>
          </div>

          {/* Body */}
          <div className="p-4 text-sm text-gray-600">
            Hi 👋  
            <br />
            Send us a message on WhatsApp and we’ll respond shortly.
          </div>

          {/* Input */}
          <div className="flex items-center gap-2 p-3 border-t">
            <input
              type="text"
              placeholder="Type a message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && openWhatsApp()}
              className="flex-1 px-3 py-2 rounded-full
                border border-gray-300 text-sm
                focus:outline-none focus:ring-2 focus:ring-[#25D366]"
            />
            <button
              onClick={openWhatsApp}
              className="bg-[#25D366] text-white
                px-4 py-2 rounded-full text-sm
                hover:bg-[#1ebe5d] transition"
            >
              Send
            </button>
          </div>
        </div>
      )}

      {/* Animation */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
}
